import React, { useMemo } from "react";
import "./QuestionGridNumber.css";
import useAppHooks from "../../../../shared/hooks/useAppHooks";

export default function QuestionGridNumber({ selectedIndex, onSelect }) {
  const { selector } = useAppHooks();
  const { practiceSolution } = selector((s) => s.analyticsSlice);
  const data = practiceSolution?.data || [];

  // Group data by subject & section
  const groupedData = useMemo(() => {
    if (!data.length) return [];
    const sections = [];
    let currentSection = null;
    data.forEach((q) => {
      const key = `${q.subject || "Unknown"} - ${q.section_name || "Section"}`;
      if (
        !currentSection ||
        currentSection.key !== key ||
        q.display_number === 1
      ) {
        currentSection = {
          key,
          subject: q.subject,
          section_name: q.section_name,
          questions: [],
        };
        sections.push(currentSection);
      }
      currentSection.questions.push(q);
    });
    return sections;
  }, [data]);

  // Compute counts for each status
  const statusCounts = useMemo(() => {
    const counts = {
      correct: 0,
      incorrect: 0,
      unattempted: 0,
      marked: 0,
    };

    data.forEach((q) => {
      let userAttempted = false;
      let userSelectedCorrect = false;

      if (q.option && Array.isArray(q.option)) {
        q.option.forEach((opt) => {
          if (opt.is_user_correct_ans === 1) {
            userAttempted = true;
            if (opt.is_correct === 1) {
              userSelectedCorrect = true;
            }
          }
        });
      } else if (q.user_answer === "WRONG") {
        userAttempted = true;
        userSelectedCorrect = false;
      }

      if (q.is_saved === true) {
        counts.marked++;
      } else if (userAttempted) {
        userSelectedCorrect ? counts.correct++ : counts.incorrect++;
      } else {
        counts.unattempted++;
      }
    });

    return counts;
  }, [data]);

  if (!data.length)
    return <p style={{ textAlign: "center" }}>No questions found</p>;

  let globalIndex = 0;

  const getClass = (q, globalI) => {
    const isSelected = globalI === selectedIndex;
    const isMarked = q.is_saved === true;

    let userAttempted = false;
    let userSelectedCorrect = false;
    if (q.option && Array.isArray(q.option)) {
      q.option.forEach((opt) => {
        if (opt.is_user_correct_ans === 1) {
          userAttempted = true;
          if (opt.is_correct === 1) {
            userSelectedCorrect = true;
          }
        }
      });
    } else if (q.user_answer === "WRONG") {
      userAttempted = true;
      userSelectedCorrect = false;
    }

    if (isSelected) return "selected";
    if (isMarked) return "marked";
    if (userAttempted) {
      return userSelectedCorrect ? "correct" : "incorrect";
    }
    return "unattempted";
  };

  return (
    <div className="questionGrid_wrapper">
      <h4 className="grid_heading">Your Response Grid</h4>
       <h4 className="grid_overview">overview</h4>

      {/* Status Legend with Counts Inside Circles */}
      <div className="overview">
        <div className="status_row">
          <span className="status_circle correct">{statusCounts.correct}</span>
          Correct
        </div>
        <div className="status_row">
          <span className="status_circle incorrect">{statusCounts.incorrect}</span>
          Incorrect
        </div>
        <div className="status_row">
          <span className="status_circle unattempted">{statusCounts.unattempted}</span>
          Unattempted
        </div>
        <div className="status_row">
          <span className="status_circle marked">{statusCounts.marked}</span>
          Marked for Review
        </div>
      </div>

      {/* Sections and Questions */}
      {groupedData.map((section, sectionIndex) => (
        <div key={sectionIndex} className="section_wrapper">
          <h5>
            {section.subject} {section.section_name}
          </h5>
          <div className="grid">
            {section.questions.map((q) => {
              const className = getClass(q, globalIndex);
              const index = globalIndex++;
              return (
                <div
                  key={index}
                  className={`grid_item ${className}`}
                  onClick={() => onSelect(index)}
                  title={`Q${q.display_number}`}
                >
                  {q.display_number}
                </div>
              );
            })}
          </div>
        </div>
      ))}
    </div>
  );
}